import React, { Component } from 'react'
import CSSModules from 'helpers/CSSModulesUtil'
import { connect } from 'react-redux'
import { compose } from 'recompose'
import { Layout, Panel, NavDrawer } from 'react-toolbox/lib/layout'
import injectSagas from 'helpers/injectSagas'

import withRedirection from 'containers/Redirect/index'
import Notification from 'containers/App/Notification/index'
import Appbar from 'containers/App/Appbar/index'
import NavigationBar from 'containers/App/NavigationBar/index'
import AppNavigationBar from 'containers/App/AppNavigationBar/index'
import AppNavigation from 'containers/App/AppNavigation/index'
import Routes from 'containers/App/routes'

import { APP } from './constants'

import {
  appPageMount,
  appPageUnmount,
  toggleNavigationDrawer
} from './actions'

import sagas from './sagas'

import {
  activeSelector,
} from './selectors'

import {
  authenticatedSelector,
} from 'containers/User/Login/selectors'

import styles from './styles.scss'

const mapStateToProps = (state) => {
  return {
    active: activeSelector(state),
    authenticated: authenticatedSelector(state), // Used to make sure we rerender login page when changed
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    toggle: () => dispatch(toggleNavigationDrawer()),
    mount: () => dispatch(appPageMount()),
    unmount: () => dispatch(appPageUnmount()),
  }
}

class App extends Component {
  componentWillMount() {
    this.props.mount()
  }

  componentWillUnmount() {
    this.props.unmount()
  }

  onOverlayClick = () => {
    const { active, toggle } = this.props
    if (active) toggle()
  }

  render() {
    const { active } = this.props
    return (
      <Layout theme={styles}>
        <NavDrawer
          theme={styles}
          active={active}
          onOverlayClick={this.onOverlayClick}>
          <AppNavigationBar/>
          <AppNavigation/>
        </NavDrawer>
        <Panel theme={styles}>
          <div styleName="appNavigationBar">
            <Appbar/>
            <NavigationBar/>
          </div>
          <Routes/>
        </Panel>
        <Notification/>
      </Layout>
    )
  }
}

const withStyles = CSSModules(styles)
const withSagas = injectSagas({ [APP]: sagas })
const withConnect = connect(mapStateToProps, mapDispatchToProps)
const enhance = compose(
  withRedirection,
  withSagas,
  withConnect,
  withStyles
)

export default enhance(App)
